import { render } from "./TemplatesView.vue?vue&type=template&id=becedf1a&scoped=true"
import script from "./TemplatesView.vue?vue&type=script&lang=js"
export * from "./TemplatesView.vue?vue&type=script&lang=js"

import "./TemplatesView.vue?vue&type=style&index=0&id=becedf1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-becedf1a"]])

export default __exports__